import React from 'react';
import { Modal } from 'antd';

class PublishInfoModal extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: false,
            item: {},

        }
    }

    show = (item) => {
        
        this.setState({
            visible: true,
            item
        })
    }

    openUrl = (url) => {
        window.open(url,'_blank')
    }

    render(){
        console.log(this.state.itemObj)
        return(
            <Modal
            title="发布信息"
            width={500}
            visible={this.state.visible}
            onCancel={() => this.setState({ visible: false})}
            onOk={() => this.setState({ visible: false})}
            >
            <div>
                <span style={{ display: 'block',  paddingBottom: 15, fontSize:15, color: '#6c748b', fontWeight: 'bolder' }}>发布链接：<span style={{ cursor: 'pointer', color: '#0050B3'}} onClick={() => this.openUrl(this.state.item.publishUrl)}>{this.state.item.publishUrl ?this.state.item.publishUrl : ''}</span> </span>
                <span style={{ display: 'block', fontSize:15, color: '#6c748b', fontWeight: 'bolder'}}>备注： { this.state.item.remark ? this.state.item.remark  : '' }</span>
            </div>

            </Modal>

        )
    }
}

export default PublishInfoModal;